// extracted by css-extract-rspack-plugin
export default {"cls1":"DownloadHeroCard-cls1_b5A","cls2":"DownloadHeroCard-cls2_1Wc DownloadHeroCard-cls1_b5A"};